module.exports = __webpack_public_path__ + "img/braco-d.cc59e171.png";